import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import globalActions from "./modules/globalActions.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mppChannels: {}, //where does the testimonial come from
    mppRatings: {}, //star ratings
    mppCategories: {}, //taxonomy
    mppGeneralAjaxResponse: "",
    mppResults: [], //a list of all results based on filter ... only a little bit of data
    mppResultDetails: {}, //contains the very details captured individually ... must be object to add further results in an assoc way
    mppNumResultsPerPageObject: { options: ['5','10','25','50','100'], selected: 10 },
    mppCurrentPage: 1, //current page of results - used to calculate offset in DB
    mppNumTotalResults: '',
    mppNumFilteredResults: '',
    mppSearchPhrase: '',
    mppSearchInText: true,
    mppSearchInTitle: true,
    mppForceFetchTotalNumberOfResults: false, //set true if to force fetch the number of all testimonials via first result load rather than via filter request... e.g. when not captured via sidebar.
    mppFetchingResultsNow: false //could be used as an indicator for fetching results - if true shows a spinner like in the results div.
  },
  getters: {
    getMPPFetchingResultsNow: state => {
      return state.mppFetchingResultsNow;
    },
    getGeneralResponse: state => {
      //console.log(state.mppGeneralAjaxResponse);
      return state.mppGeneralAjaxResponse;
    },
    getMPPChannels: state => {
      return state.mppChannels;
    },
    getMPPStars: state => {
      return state.mppRatings;
    },
    getMPPResults: state => {
      return state.mppResults;
    },
    getMPPResultsPerPageObject: state => {
      return state.mppNumResultsPerPageObject;
    },
    getMPPResultCurrentPage: state => {
      return state.mppCurrentPage;
    },
    getMPPTestimonialDetails: state => {
      return state.mppResultDetails;
    },
    getMPPTotalResultsNum: state => {
      return state.mppNumTotalResults;
    },
    getMPPFilteredResultsNum: state => {
      return state.mppNumFilteredResults;
    },
    getMPPSearchPhrase: state => {
      return state.mppSearchPhrase;
    },
    getMPPSearchInTitle: state => {
      return state.mppSearchInTitle;
    },
    getMPPSearchInText: state => {
      return state.mppSearchInText;
    },
    getMPPForceFetchTotalNumberOfResults: state => {
      return state.mppForceFetchTotalNumberOfResults;
    }
  },
  mutations: {
    setMPPFetchingResultsNow: (state, booleanValue) => {
      state.mppFetchingResultsNow = booleanValue;
    },
    setMPPSearchPhrase: (state, searchString) => {
      state.mppSearchPhrase = searchString;
    },
    setMPPSearchInTitle: (state, boolean) => {
      state.mppSearchInTitle = boolean;
    },
    setMPPSearchInText: (state, boolean) => {
      state.mppSearchInText = boolean;
    },
    setNumTotalResults: (state, num) => {
      state.mppNumTotalResults = num;
    },
    setMPPFilteredResultsNum: (state, num) => {
      state.mppNumFilteredResults = num;
    },
    setGeneralResponse: (state, response) => {
      state.mppGeneralAjaxResponse = response;
    },
    setChannels: (state, channelObject) => {
      state.mppChannels = channelObject;
    },
    setStars: (state, channelObject) => {
      state.mppRatings = channelObject;
    },
    replaceSpecificChannel: (state, subChannelObject) => {
      state.mppChannels[subChannelObject.channelIndex] = subChannelObject.channelData;
    },
    setMPPResults: (state, resultObject) => {
      state.mppResults = resultObject;
    },
    addMPPResults: (state, resultObject) => {
      state.mppResults = state.mppResults.concat(resultObject);
    },
    setMPPNumResPerPageSelected: (state, selectedValue) => {
      state.mppNumResultsPerPageObject.selected = selectedValue;
    },
    setMPPCurrentPage: (state, currentPage) => {
      state.mppCurrentPage = currentPage;
    },
    addMPPTestimonialDetails: (state, detailsObject) => {
      const fm_id = detailsObject.info.fm_id;
      //console.log(fm_id);
      state.mppResultDetails[fm_id] = detailsObject.data;
    },
    mppSetForceFetchTotalResults: (state, booleanValue) => {
      state.mppForceFetchTotalNumberOfResults = booleanValue;
    }
  },
  actions: {
    setMPPFetchingResultsNow: ({commit}, booleanValue) => {
      commit('setMPPFetchingResultsNow', booleanValue);
    },
    setMPPSearchPhrase: ({commit}, searchString) => {
      commit('setMPPSearchPhrase', searchString);
    },
    setMPPSearchInTitle: ({commit}, boolean) => {
      commit('setMPPSearchInTitle',boolean);
    },
    setMPPSearchInText: ({commit}, boolean) => {
      commit('setMPPSearchInText', boolean)
    },
    setGeneralResponse: ({commit}, response) => {
      commit('setGeneralResponse', response);
    },
    setChannels: ({commit}, channelsDataObject) => {
      commit('setChannels', channelsDataObject);
    },
    setStars: ({commit}, starDataObject) => {
      commit('setStars', starDataObject);
    },
    replaceSpecificChannel: ({commit}, subChannelDataObject) => {
      commit('replaceSpecificChannel', subChannelDataObject);
    },
    setMPPResults: ({commit}, resultObject) => {
      commit('setMPPResults', resultObject);
    },
    addMPPResults: ({commit}, resultObject) => {
      commit('addMPPResults', resultObject);
    },
    setMPPNumResPerPageSelected: ({commit}, selectedValue) => {
      commit('setMPPNumResPerPageSelected',selectedValue);
    },
    setMPPCurrentPage: ({commit}, currentPageProvided) => {
      commit('setMPPCurrentPage', currentPageProvided);
    },
    addMPPTestimonialDetails: ({commit}, detailsObject) => {
      commit('addMPPTestimonialDetails', detailsObject);
    },
    setNumTotalResults: ({commit}, num) => {
      commit('setNumTotalResults', num);
    },
    setMPPFilteredResultsNum: ({commit}, num) => {
      commit('setMPPFilteredResultsNum', num);
    },
    mppSetForceFetchTotalResults: ({commit}, booleanValue) => {
      //return a value, so it can be used in chained ajax requests where one action waits for the other in order to work correctly.
      return new Promise((resolve, reject) => {
        commit('mppSetForceFetchTotalResults', booleanValue)
        resolve(true);
      });
    }
  },
  modules: {
    globalActions
  }
});